// extracted by mini-css-extract-plugin
export var basicBorderRadius = "Button-module__basicBorderRadius___TaX9J";
export var buttonBase = "Button-module__buttonBase___olICK";
export var buttonIcon = "Button-module__buttonIcon___540Jm";
export var buttonSwitch = "Button-module__buttonSwitch___+Tn3u";
export var callToAction = "Button-module__callToAction___mSaZg";
export var decoratedButton = "Button-module__decoratedButton___-YJyr";
export var defaultBase = "Button-module__defaultBase___c7wIT";
export var heroLargeBorderRadius = "Button-module__heroLargeBorderRadius___u9CMS";
export var heroMediumBorderRadius = "Button-module__heroMediumBorderRadius___dUTPQ";
export var heroSmallBorderRadius = "Button-module__heroSmallBorderRadius___ywhQ0";
export var heroXSmallBorderRadius = "Button-module__heroXSmallBorderRadius___tyver";
export var iconButtonBase = "Button-module__iconButtonBase___uzoKc";
export var marginLeft = "Button-module__marginLeft___Bqq-9";
export var marginRight = "Button-module__marginRight___0vEpe";
export var noMargin = "Button-module__noMargin___5UbzU";
export var overlayModeAcrylic = "Button-module__overlayModeAcrylic___QnjAv";
export var overlayModeSemiTransparent = "Button-module__overlayModeSemiTransparent___mcpLM";
export var overlayModeSolid = "Button-module__overlayModeSolid___v6EcO";
export var secondarySwitchBackplate = "Button-module__secondarySwitchBackplate___E47IF";
export var sizeIconButtonLarge = "Button-module__sizeIconButtonLarge___tb4rx";
export var sizeIconButtonMedium = "Button-module__sizeIconButtonMedium___WJrxo";
export var sizeIconButtonSmall = "Button-module__sizeIconButtonSmall___gTDbb";
export var sizeIconButtonXSmall = "Button-module__sizeIconButtonXSmall___sYhWs";
export var sizeLarge = "Button-module__sizeLarge___Jsfxn";
export var sizeMedium = "Button-module__sizeMedium___T+8s+";
export var sizeSmall = "Button-module__sizeSmall___9uKpA";
export var sizeXSmall = "Button-module__sizeXSmall___TGAST";
export var textNoUnderline = "Button-module__textNoUnderline___kHdUB";
export var textUnderline = "Button-module__textUnderline___JSRLr";
export var typeBrand = "Button-module__typeBrand___MMuct";
export var typePrimary = "Button-module__typePrimary___0WI8b";
export var typeSecondary = "Button-module__typeSecondary___Cid02";
export var typeTertiary = "Button-module__typeTertiary___wNh6R";
export var typeUserAccent = "Button-module__typeUserAccent___lK-yy";